import React from 'react'
import { WarningOutlined } from '@ant-design/icons'
import { useLanguage } from 'context/LanguageContext'
import { translations } from '../Footer/translations'
import s from './DisclaimerBar.module.scss'

export const DisclaimerBar: React.FC = React.memo(() => {
    const { language } = useLanguage()
    const { disclaimerTitle, disclaimer } =
        translations[language] || translations.en

    return (
        <aside className={s.bar} aria-label={disclaimerTitle}>
            <div className={s.inner}>
                <h2 className={s.label}>
                    <WarningOutlined className={s.icon} />
                    {disclaimerTitle}
                </h2>
                <p className={s.text}>{disclaimer}</p>
            </div>
        </aside>
    )
})
